import type { TFunction } from 'i18next';

const AUTH_ERROR_KEYS: Record<string, string> = {
  sign_in_expired: 'auth.signInExpired',
  sign_in_failed: 'auth.signInFailed',
  sign_in_invalid: 'auth.signInInvalid',
};

export function authErrorMessage(code: string | null, t: TFunction): string | null {
  if (!code) return null;
  const key = AUTH_ERROR_KEYS[code] ?? 'auth.signInFailed';
  return t(key);
}

export function consumeAuthErrorFromUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const code = params.get('auth_error');
  if (!code) return null;

  params.delete('auth_error');
  const nextSearch = params.toString();
  const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
  window.history.replaceState(window.history.state, '', nextUrl);
  return code;
}
